import { SonarState } from '@app';
import { EqualityFn, shallowEqual, useSelector } from 'react-redux';

export function useSonarSelector<T>(selectorFn: (state: SonarState) => T, equalityFn?: EqualityFn<T>): T {
	return useSelector(selectorFn, equalityFn);
}

export function useSonarShallowSelector<T>(selectorFn: (state: SonarState) => T): T {
	return useSonarSelector<T>(selectorFn, shallowEqual);
}
